import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/authentication.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { JsonPipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.css']
})
export class UserLoginComponent implements OnInit, OnDestroy {
  email: string;
  password: string;
  loginMessage: any;
  authSubscription: Subscription;
  userData: any;


  constructor(public authenticationService: AuthenticationService, private angularFireAuth: AngularFireAuth, private router: Router) {
  }


  ngOnInit(): void {
    this.authSubscription = this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        console.log('navigating');
        await this.router.navigate(['/tests']);
      }
    });

  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }


  async signIn() {
    try {
      // may need to push into service
      // need to determine how to bubble error
      const res = await this.angularFireAuth.signInWithEmailAndPassword(this.email, this.password);
      console.log(JSON.stringify(res));
    } catch (e) {
      console.log(e);
      this.loginMessage = e;
    }

  }

}
